export const Selectors = {
	Gray: 'ui-kit-gray-button',
	Contained: 'ui-kit-contained-button',
	Link: 'ui-kit-link-button',
	Outlined: 'ui-kit-outlined-button',
	Hide: 'ui-kit-hide-button',
	Text: 'ui-kit-text-button',
	Icon: 'ui-kit-icon-button',
};
